module.exports = __webpack_public_path__ + "img/Inchoilogo.fdea5747.svg";